export function concatSubNameAndNumber(name?: string, number?: string) {
	if (name && number) return `${name} (${number})`;
	if (name) return name;
	if (number) return number;
	return undefined;
}
